import {css} from '@emotion/react';
import styled from '@emotion/styled';

import {MapNotification} from '@/components/MapNotification';
import {MapViewport} from '@/components/MapViewport';

type Props = {
  withDefaultControls: boolean;
};

export const MapElements = styled.div<Props>(
  ({withDefaultControls}: Props) => css`
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: end;
    gap: 16px;
    padding: 16px;
    pointer-events: none;

    > * {
      pointer-events: all;
    }

    ${MapViewport} {
      position: absolute;
      top: 38px;
      left: 16px;
      right: 16px;
      bottom: 16px;
    }

    ${MapNotification} {
      width: 100%;
      margin-bottom: auto;
      display: flex;
      justify-content: center;
      pointer-events: none;

      > * {
        box-sizing: border-box;
        width: 100%;
        max-width: 720px;
        pointer-events: all;
        ${withDefaultControls &&
        css`
          /* assumes width of zoom control */
          margin: 0 48px;
        `}
      }
    }
  `
);
